import { useHistory, useLocation } from "react-router";
import React, { useCallback, useContext, useEffect } from "react";
import { GlobalContext } from "../GlobalContext";
import { Spin } from "../core/views/Spin";
import { Redirect } from "react-router-dom";
import { addNotification } from "../AppNotification";

/**
 * Get zendesk redirect url from location's search params
 * @param {string} searchString
 * @returns {string}
 */
export function getZendeskReturnTo(searchString: string) {
  const params = new URLSearchParams(searchString);
  return params.get("return_to");
}
const zendeskZwtLoginUrl = (jwt: string, returnTo?: string) => {
  const url = new URL("https://upsolver.zendesk.com/access/jwt");
  if (returnTo) {
    url.searchParams.append("return_to", returnTo);
  }
  url.searchParams.append("jwt", jwt);
  return url;
};

/**
 * Try to get zendesk redirect url and token
 * @param jwt
 * @returns {{token: string, to: string}}
 */
export function useZendeskAuthorization() {
  const history = useHistory();
  const { auth } = useContext(GlobalContext);
  const location = useLocation();
  return [
    useCallback(async () => {
      const token = await auth.zendeskToken();
      window.location.href = zendeskZwtLoginUrl(token, getZendeskReturnTo(location.search)).toString();
    }, [location, history]),
  ];
}

/**
 * Attempt to redirect logged in users back to zendesk as authorized
 * @param {{jwt?: "zendesk"}} props
 * @returns {JSX.Element}
 * @constructor
 */
export function ZendeskRedirect(props: { jwt?: "zendesk" }) {
  const history = useHistory();
  const [redirect] = useZendeskAuthorization();
  useEffect(() => {
    if (props.jwt === "zendesk") {
      redirect().catch((err) => {
        if (typeof err === "string") {
          addNotification({ level: "warning", message: err });
        }
        history.push("/");
      });
    }
  }, [props.jwt]);
  if (props.jwt) {
    return <Spin />;
  } else {
    return <Redirect to="/" />;
  }
}
